import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBuilding,
  cilCloud,
  cilCloudDownload,
  cilCloudUpload,
  cilControl,
  cilEducation,
  cilEnvelopeClosed,
  cilFactory,
  cilHome,
  cilInbox,
  cilMonitor,
  cilSettings,
  cilStorage,
  cilSwapHorizontal,
  cilUser,
  cilUserFollow,
} from '@coreui/icons'

export const _nav = [
  {
    name: 'Home',
    to: '/',
    icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
    permissions: ['authenticated'],
  },
  {
    name: 'Input',
    icon: <CIcon icon={cilInbox} customClassName="nav-icon" />,
    permissions: ['agent-email-message-read', 'tpm-part-create', 'agent-gmail-read'],
    children: [
      {
        name: 'Inbox Email',
        to: '/emails',
        icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
        permission: 'agent-email-message-read',
      },
      {
        name: 'Upload Email',
        to: '/tpm/msg',
        icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
        permission: 'tpm-part-create',
      },
      {
        name: 'Gmail Agent',
        to: '/agents/gmail',
        icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
        permission: 'agent-gmail-read',
      },
    ],
  },
  {
    name: 'Trading Prices',
    icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
    permissions: ['tpm-part-read', 'tpm-offer-read', 'tpm-rfq-read'],
    children: [
      {
        name: 'Catalog Piese',
        to: '/tpm/parts',
        icon: <CIcon icon={cilStorage} customClassName="nav-icon" />,
        permission: 'tpm-part-read',
      },
      {
        name: 'Oferte Preturi',
        to: '/tpm/offers',
        icon: <CIcon icon={cilCloudDownload} customClassName="nav-icon" />,
        permission: 'tpm-offer-read',
      },
      {
        name: 'Cereri de Oferta',
        to: '/tpm/rfq',
        icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
        permission: 'tpm-rfq-read',
      },
      {
        name: 'Curs Valutar',
        to: '/curs-valutar',
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ],
  },
  {
    name: 'Agents',
    icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
    permissions: ['agent-read', 'tpm-part-update'],
    children: [
      {
        name: 'Email',
        to: '/agents/emails',
        icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
        permission: 'agent-email-read',
      },
      {
        name: 'Agent Procesare Email',
        to: '/tpm/agent',
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
        permission: 'tpm-part-update',
      },
      {
        name: 'Agent Structura Excel',
        to: '/tpm/excel-agent',
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
        permission: 'tpm-part-update',
      },
    ],
  },
  {
    name: 'Connectors',
    icon: <CIcon icon={cilSwapHorizontal} customClassName="nav-icon" />,
    permissions: ['connector-read'],
    children: [
      {
        name: 'Email Office365',
        to: '/connectors/email-office365',
        icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
        permission: 'connector-email-office365-read',
      },
      {
        name: 'AI',
        to: '/connectors/ai',
        icon: <CIcon icon={cilEducation} customClassName="nav-icon" />,
        permission: 'connector-ai-read',
      },
      {
        name: 'ERP',
        to: '/connectors/erp',
        icon: <CIcon icon={cilFactory} customClassName="nav-icon" />,
        permission: 'connector-erp-read',
      },
      {
        name: 'Gmail',
        to: '/connectors/gmail',
        icon: <CIcon icon={cilEnvelopeClosed} customClassName="nav-icon" />,
        permission: 'connector-gmail-read',
      },
    ],
  },
  {
    name: 'Administration',
    icon: <CIcon icon={cilMonitor} customClassName="nav-icon" />,
    permissions: ['user-read', 'role-read'],
    children: [
      {
        name: 'Users',
        to: '/users',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        permission: 'user-read',
      },
      {
        name: 'Roles',
        to: '/roles',
        icon: <CIcon icon={cilUserFollow} customClassName="nav-icon" />,
        permission: 'role-read',
      },
    ],
  },
  {
    name: 'System',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    children: [
      {
        name: 'Logs',
        to: '/logs',
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
        permission: 'logs-read',
      },
      {
        name: 'Parametri',
        to: '/parametri',
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ],
  },
]
